const domify = require('domify');
const throttle = require('lodash/throttle');
const _ = require('./i18n');

class FacetsSpoiler {
  constructor(element) {
    this.element = element;
    this.itemsList = this.element.querySelector('.facet-items');
    if (!this.itemsList) { return; }

    this.items = [...this.itemsList.querySelectorAll('.facet-item')];
    this.showAll = domify('<div class="facets-showAll"></div>');

    // prepend `showAll` button
    this.itemsList.insertBefore(this.showAll, this.items[0]);

    this.render();
    this.bindEvents();
  }

  bindEvents() {
    this.showAll.addEventListener('click', () => this.show());
    window.addEventListener('resize', throttle(() => {
      this.render();
      if (this.hasVisibleActiveElementsNotInFirstLine()) {
        this.show();
      }
    }, 200));
  }

  hasVisibleActiveElementsNotInFirstLine() {
    const firstOffset = this.items[0].offsetTop;
    return !!this.items
      .filter((i) => i.offsetTop > firstOffset)
      .filter((i) => i.classList.contains('active'))
      .length;
  }

  countElementNotInFirstLine() {
    const nonEmpty = this.items.filter((i) => !i.classList.contains('empty'));
    if (!nonEmpty.length) {
      return 0;
    }
    const firstOffset = nonEmpty[0].offsetTop;
    return nonEmpty
      .filter((i) => i.offsetTop > firstOffset)
      .length;
  }

  show() {
    this.itemsList.classList.add('facet-items--opened');
  }

  render() {
    if (!this.itemsList) { return; }

    if (this.itemsList.classList.contains('facet-items--opened')) {
      return;
    }

    if (this.hasVisibleActiveElementsNotInFirstLine()) {
      this.show();
      return;
    }

    this.showAll.setAttribute('hidden', 'hidden');

    const invisibleItemsNumber = this.countElementNotInFirstLine();
    if (invisibleItemsNumber) {
      this.showAll.removeAttribute('hidden');
      const text = this.interpolate(
        this.ngettext(
          '%s filter more',
          '%s filters more',
          invisibleItemsNumber,
        ),
        [invisibleItemsNumber],
      );
      this.showAll.innerHTML = `
        <span class="facets-showAllText">${text}</span>
      `;
    }
  }

  // for mocking in tests
  ngettext(...args) {
    return _.ngettext(...args);
  }

  interpolate(...args) {
    return _.interpolate(...args);
  }
}

module.exports = FacetsSpoiler;
